export class PseTransaction {
    constructor(
        public typeDI= '',
        public di= '',
        public name= '',
        public lastName= '',
        public personType= '',
        public bank= '',
        public token= '',
        public email = '',
        public cellPhone = '',
        public address = '',
    ) { }
}
